import { ORDER_ASC, ORDER_DESC } from "../constants/constants";

export type HeaderTables = {
  label: string;
  key?: string;
  html?: boolean;
  translateValue?: boolean;
  searchable?: boolean;
};

export type DataTables = {
  id: string;
  headerKey: string;
};

export enum EventKindEnum {
  OD = "Open Day",
  OWD = "Open Week Dealer",
  OWA = "Open Week Architects",
}

export type ItemDate = { date: string; start: string; end: string };

export enum InvitedKindEnum {
  Person = "Person",
  Dealer = "Dealer",
}

export enum InvitedStatusesEnum {
  Invited = "invited",
  Uninvited = "uninvited",
  Registered = "registered",
  CheckedIn = "checked_in",
}

export type ActionsTable = {
  label: string;
  icon: string;
  // event può essere qualunque cosa oltre l'id
  handler: (event: any) => void;
};

export enum StoreTypes {
  ExperienceStore = "Experience Store",
  FlagShipStore = "Flagship Store",
}

export enum Roles {
  Admin = "admin",
  StoreManager = "store_manager",
  KAM = "kam",
}

export enum Order {
  ASC = ORDER_ASC,
  DESC = ORDER_DESC,
}

export type SortType =
  | {
      _sort: string;
      _order: Order;
    }
  | undefined;

export enum ApplicationStatusEnum {
  NotSubmitted = "Not submitted",
  Submitted = "Submitted",
  Refused = "Refused",
  Validated = "Validated",
}
